export default __webpack_public_path__ + "static/media/s2s_image_2.47cd1f12.png";